<template>
    <div class="row">
        <!-- admin view -->
        <div class="col-12" v-if="isAdmin">
            <card card-body-classes="" no-footer-line>
                <h4 slot="header" class="card-title text-right" v-if="programme">
                    <n-button
                        @click.native="handleEdit(programme.slug)"
                        class="edit"
                        type="warning"
                        size="sm"
                        round
                        simple
                    >
                        <i class="fa fa-pencil"></i> Edit
                    </n-button>
                </h4>
                <PreviewForm v-if="programme" v-bind="programme" entity="programme"  @on-pool="gotParticipants" :withSubmit="false"></PreviewForm>
                <div class="events mt-5" v-if="programme">
                    <p class="card-text">Events ({{ programme.events.length }})</p>
                    <!-- admin viewing as student -->
                    <div class="row justify-content-start" v-if="this.$route.params.batch">
                        <div class="col-md-4 col-lg-3" v-for="(event, index) in programme.events" :key="index">
                            <PreviewCard v-bind="event" entity="event"></PreviewCard>
                        </div>
                    </div>
                    <!-- admin viewing as admin -->
                    <tabs type="primary" v-else>
                        <tab-pane :label="event.title" v-for="(event, index) in programme.events" :key="index">
                            <PreviewForm v-bind="event" entity="event" :participants_pool="programme.participants_pool" :withSubmit="false"></PreviewForm>
                        </tab-pane>
                    </tabs>
                </div>
            </card>
        </div>
        <!-- student view -->
        <div class="col-12" v-else>
            <RegisterForm v-if="programme" v-bind="programme" entity="programme"  @on-pool="gotParticipants" :withSubmit="programme.isOpen"></RegisterForm>
                
            <div class="row justify-content-start" v-if="programme">
                <div class="col-md-4 col-lg-3 col-sm-6 col-xs-12" v-for="(event, index) in programme.events" :key="index">
                    <PreviewCard v-bind="event" entity="event" v-on:card-click="onCardClick"></PreviewCard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { PreviewForm, RegisterForm, PreviewCard, Tabs, TabPane, } from "src/components";
import swal from "sweetalert2";

import { mapGetters } from 'vuex';

export default {
    components: {
        PreviewForm,
        RegisterForm,
        PreviewCard,
        [Tabs.name]: Tabs,
        [TabPane.name]: TabPane,
    },
    computed: {
        ...mapGetters({
            programme: 'getProgramme',
            authTokens: 'getAuthTokens',
            preferences: 'getPreferences'
        }),
        isAdmin(){
            return (this.$currentUser) ? this.$currentUser.roles.includes('admin') : false
        },
        
    },
    methods: {
        handleEdit(slug) {
            this.$router.push(`/programmes/edit/${slug}`)
        },
        gotParticipants(pool){
        // Note:- Work around for this.programme.participants_pool = pool
        // Vue is not reactive for such changes
        // https://vuejs.org/v2/guide/list.html#Object-Change-Detection-Caveats
        // Vue does not allow dynamically adding new root-level reactive properties to an already created instance.
        // However, it’s possible to add reactive properties to a nested object using the Vue.set(object, propertyName, value) 
        this.$set(this.programme, 'participants_pool', pool)
        },
        onCardClick(link){
            this.$router.push(`/events/view/${link}`)
        }
    },
    mounted() {
        this.$store.commit('setProgramme', null)

        if(this.$route.params.batch){
            this.$store.dispatch('getProgrammeByBatch', {
                slug: this.$route.params.slug,
                batch: this.$route.params.batch
            })
        }
        else{
            this.$store.dispatch('getProgramme', this.$route.params.slug);
        }

    },
    watch: {
    }
};
</script>
<style lang="scss">
.nav-pills{
    .nav-item{
        margin-bottom: 10px;
    }
}
</style>

